import React from 'react'
import PropTypes from 'prop-types'

// @ts-ignore
import SelectMultiGenericValueEmpty from "./value/value-empty"
// @ts-ignore
import SelectMultiGenericValueNotEmpty from "./value/value-not-empty"
// @ts-ignore
import SelectMultiGenericPopoverMenu from "./popover/popover-menu"

const debug = false
// const debug = "SelectMultiGenericNew"

export default class SelectMultiGenericNew extends React.Component<any,any> {

    public previousOptions      : any

    static propTypes = {
        options                         : PropTypes.array,  // dropdown options
        values                          : PropTypes.any,    // current values

        placeholder                     : PropTypes.string, //
        allValuesOptionLabel            : PropTypes.string, // label for select all options button ?

        popoverClasses                  : PropTypes.string,
        popoverScrollContainerClasses   : PropTypes.string,

        allValuesOption                 : PropTypes.bool,   // is all values option available
        isSearchable                    : PropTypes.bool,   // is used in popover
        disabled                        : PropTypes.bool,

        valueComponent                  : PropTypes.func,   // render value component redefine
        valueEmptyComponent             : PropTypes.func,   // empty value component redefine

        iconComponent                   : PropTypes.func,   // is used in default SelectMultiGenericValueEmpty component
        popoverOptionComponent          : PropTypes.func,   // redefine

        onChange                        : PropTypes.func,
    }

    static defaultProps = {
        placeholder             : 'Please select',
        allValuesOption         : false,
        allValuesOptionLabel    : 'All'
    }

    constructor(props:any) {
        super(props);

        this.state = {
            currentOptions  : props.values,
            showPopover     : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        if (props.values !== state.initialPropsValues) {
            return {
                initialPropsValues  : props.values,
                currentOptions      : props.values,
            }
        }
        return null
    }

    showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any) => {
        let currentOptions = this.state.currentOptions ? this.state.currentOptions.slice() : []
        this.previousOptions = currentOptions;

        if (!!option.isAllValuesOption) {
            // all values option click
            currentOptions = null
        } else {
            currentOptions = gd.utils.toggleArrayValue(currentOptions, option.value);
        }

        this.setState({
            currentOptions: currentOptions
        }, () => {
            if (this.props.onChange) this.props.onChange(currentOptions, this.onCancelChange);
        })
    }

    onCancelChange = () => {
        this.setState({
            currentOptions: this.previousOptions
        });
    }

    _getOptions(values:any) {
        if (values) {
            const options = _.filter(this.props.options, option => values.includes(option.value))
            if (!_.isEmpty(options)) return options
        }

        return false
    }

    _getValueComponent = (selectedOptions:any) => {
        let ValueComponent

        if (!!selectedOptions && selectedOptions.length > 0) {
            ValueComponent = this.props.valueComponent || SelectMultiGenericValueNotEmpty
        } else {
            ValueComponent = this.props.valueEmptyComponent || SelectMultiGenericValueEmpty
        }

        return ValueComponent
    }

    render() {
        const classes = Classes(this.props.className, {
            'show-popover'  : this.state.showPopover,
            'disabled'      : this.props.disabled
        });

        const selectedOptions = this._getOptions(this.state.currentOptions)
        let ValueComponent = this._getValueComponent(selectedOptions)

        debug && console.log(debug, "render", this.props.placeholder, this.state.currentOptions, selectedOptions)

        return (
            <React.Fragment>
                <ValueComponent className               = {classes}
                                placeholder             = {this.props.placeholder}
                                allValuesOption         = {this.props.allValuesOption}
                                allValuesOptionLabel    = {this.props.allValuesOptionLabel}
                                iconComponent           = {this.props.iconComponent}
                                options                 = {selectedOptions}
                                onClick                 = {!this.props.disabled ? this.showPopover : null}
                                onDelete                = {!this.props.disabled ? this.onOptionClick : null}>
                </ValueComponent>
                {this.state.showPopover && <SelectMultiGenericPopoverMenu {...this.props} parent={this}/>}
            </React.Fragment>
        )
    }
}